import ApiWrapper from "./ApiWrapper"

var ThirdPartyAuthService = {
    google({ token }) {
        return ApiWrapper.post('/api/ThirdPartyAuth/Google', { token });
    }
}

export default ThirdPartyAuthService
